import script from "./DeptTag.vue?vue&type=script&setup=true&lang=js"
export * from "./DeptTag.vue?vue&type=script&setup=true&lang=js"

import "./DeptTag.vue?vue&type=style&index=0&id=58091aa7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58091aa7"]])

export default __exports__